import React, { PureComponent } from 'react';
import { Row, Col } from 'react-bootstrap';
import actions from '../../../constants/actions';

class AlertsList extends PureComponent {
  onPressAction = (id, action) => {
    this.props.showModalHandle(id, action);
  }

  render() {
    const {
      list,
    } = this.props;

    return (
      <div className="alerts-container">
        <h2>Alerts</h2>
        <Row className="alerts-rows-container">
          <Col sm={12}>
            {
              list.length > 0 ? 
              list.map((item, index) => (
                <Row className="alert-row" key={`alert-${index}-rows`}>
                  <Col sm={12}>
                    <p>
                      {item.label} has been hidden because the URL is no longer valid,
                      &nbsp;
                      <span
                        onClick={() => this.onPressAction(item.id, actions.edit)}>
                        click here
                      </span>
                      &nbsp;
                      to change it.
                    </p>
                  </Col>
                </Row>
              ))
              :
              <Row className="alert-row">
                <Col sm={12}>
                  <p>
                    No broken links.
                  </p>
                </Col>
              </Row>
            }
          </Col>
        </Row>
      </div>
    );
  }
}

export default AlertsList;



// WEBPACK FOOTER //
// ./src/app/screens/dashboard/alertsList.js